import {
  ApplicationPath,
  NavigationTab,
} from '../types/application-path.types';

const applicationPathMapping: Record<ApplicationPath, unknown> = {
  zoom: true,
  noise: true,
  'zoom-noise': true,
  hr: true,
  raw: true,
  ilr: true,
  resting: true,
  clean: true,
  merge: true,
};

export const isApplicationPath = (path: string): path is ApplicationPath =>
  path in applicationPathMapping;

export const getApplicationPath = (location: Location) => {
  const pathValues = location.pathname.split('/');
  const lastValue = pathValues[pathValues.length - 1];

  return isApplicationPath(lastValue) ? lastValue : null;
};

export const setDefaultPathIndex = (
  tabs: NavigationTab[],
  path: ApplicationPath,
): number => tabs.findIndex((tab) => tab.path === path);
